import { from, Observable } from "rxjs";
import { apiClient } from "./api";
import { map } from "rxjs/operators";
import { ENDPOINTS } from "@/settings/api-settings";
import { AgendamentoVisitaFiltroDTO, AgendamentoVisitaParmDTO } from "@/interfaces/crm-visit-planning";
import { ResultPagDTO } from "@/interfaces/base-dto";

export function getCrmVisitPlanningInstitution(id): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_PLANNING_INSTITUTIONS.replace('{id}', id))).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}


export function saveCrmVisitPlanning(parm: AgendamentoVisitaParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.CRM_VISIT_PLANNING, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function updateCrmVisitPlanning(parm: AgendamentoVisitaParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.CRM_VISIT_PLANNING, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmVisitPlanning(filters: AgendamentoVisitaFiltroDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_PLANNING, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function getCrmVisitPlanningDetails(id: Number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.CRM_VISIT_PLANNING}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function deleteCrmVisitPlanning(id: Number): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.CRM_VISIT_PLANNING}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function getCrmVisitPlanningUserCycle(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.CRM_VISIT_PLANNING_USER_CYCLE}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmVisitPlanningVisitors(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_PLANNING_VISITORS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmVisitPlanningContacts(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_PLANNING_CONTACTS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}
